export const RENTAL = {
  nickname: 'PRODUCTS.RENTAL.nickname',
  icon:'rental'
};
